<template>
  <div class="container">
    <div class="scroll-wrap">
      <div v-if="dataList.length>0" class="list-wrap">
        <div v-for="(item,index) in dataList" :key="index">
          <ArticleCard :item="item" :type="getPostType(item.postType)" @collect-change="handleCollectChange"/>
        </div>
      </div>
      <Empty v-else content="暂无收藏内容"/>
    </div>

    <div class="pagination-bar" v-if="total > 0">
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="Number(total)"
          :current-page="pageNum"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Empty from '@/components/empty'
  import ArticleCard from '@/components/articleCard'
  import qs from 'qs'
  import { post, ajaxParam } from '@/units/request.js'
  export default {
    name: 'myCollection',
    components: {
      ArticleCard,
      Empty
    },
    data(){
      return{
        userId: '',
        pageNum: 1,
        pageSize: 10,
        dataList: [],
        total: 0
      }
    },
    created(){
      this.userId = localStorage.getItem('userId')||''
      this.getCollectList()
    },
    methods: {
      getPostType(postType) {
        const typeMap = {
          0: 'ARTICLE',
          1: 'TRENDS',
          2: 'VIDEO',
          3: 'SUGGEST',
          4: 'QUESTION',
          5: 'FEEDBACK'
        }
        return typeMap[postType] || 'ARTICLE'
      },
      async getCollectList(){
        let param = {
          userId: this.userId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        ajaxParam(param)
        const res = await post('v1/circle/userCollectPostList', qs.stringify(param))
        if(res.data.code==200){
          this.dataList = res.data.list
          this.total = res.data.total
          this.dataList.forEach(item => {
            item.isCollect = 1
          })
        } else {
          this.$message.error(res.data.msg)
        }
      },
      handleCurrentChange(page){
        this.dataList = []
        this.pageNum = page
        this.getCollectList()
      },
      handleCollectChange(item){
        if (item.isCollect !== 1) {
          // 取消收藏后重新获取列表
          this.getCollectList()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    position: relative;
    background: #fff;
    padding: 20px;
    min-height: 600px;
    display: flex;
    flex-direction: column;

    .scroll-wrap {
      flex: 1;
    }

    .list-wrap {
      padding: 10px 0;
    }

    .pagination-bar{
      flex: 0 0 auto;
      background: #fff;
      padding-top: 10px;
    }

    .pagination-wrap{
      display: flex;
      justify-content: center;
      margin: 30px 0 0;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: var(--color-text-a);
      color: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li:hover{
      color: var(--color-text-a)
    }
  }
</style>
